import React, { useState } from 'react';
import { Bot, ShoppingCart, LineChart, Users } from 'lucide-react';
import { SalesForm } from './SalesForm';
import { GetStartedForm } from './GetStartedForm';
export function AgentGallery() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState('');
  const handleTryAgent = agentName => {
    setSelectedAgent(agentName);
    setIsFormOpen(true);
  };
  return <section id="agent-gallery" className="py-16 md:py-24 bg-gray-50" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="text-center mb-16" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-42">
            Agent Gallery
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-43">
            Discover ready-to-use AI agents that can transform how your business
            operates.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-44">
          <div className="bg-white p-6 rounded-xl border border-gray-100" data-id="element-45">
            <div className="flex items-center space-x-4 mb-4" data-id="element-46">
              <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center" data-id="element-47">
                <Bot size={24} data-id="element-48" />
              </div>
              <div data-id="element-49">
                <h3 className="text-xl font-semibold" data-id="element-50">
                  Customer Support Agent
                </h3>
                <p className="text-gray-500 text-sm" data-id="element-51">
                  Responds to common questions 24/7
                </p>
              </div>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-52">
              Handles customer inquiries, provides product information, and
              resolves common issues without human intervention.
            </p>
            <div className="flex justify-between items-center" data-id="element-53">
              <div className="flex items-center space-x-1" data-id="element-54">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-55">
                  Popular
                </span>
              </div>
              <button onClick={() => handleTryAgent('Customer Support Agent')} className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-56">
                Try this agent
              </button>
            </div>
          </div>
          <div className="bg-white p-6 rounded-xl border border-gray-100" data-id="element-57">
            <div className="flex items-center space-x-4 mb-4" data-id="element-58">
              <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center" data-id="element-59">
                <ShoppingCart size={24} data-id="element-60" />
              </div>
              <div data-id="element-61">
                <h3 className="text-xl font-semibold" data-id="element-62">
                  Order Processing Agent
                </h3>
                <p className="text-gray-500 text-sm" data-id="element-63">
                  Automates your sales workflow
                </p>
              </div>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-64">
              Processes orders, checks inventory, sends confirmations, and
              coordinates with shipping providers automatically.
            </p>
            <div className="flex justify-between items-center" data-id="element-65">
              <div className="flex items-center space-x-1" data-id="element-66">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800" data-id="element-67">
                  New
                </span>
              </div>
              <button onClick={() => handleTryAgent('Order Processing Agent')} className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-68">
                Try this agent
              </button>
            </div>
          </div>
          <div className="bg-white p-6 rounded-xl border border-gray-100" data-id="element-69">
            <div className="flex items-center space-x-4 mb-4" data-id="element-70">
              <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center" data-id="element-71">
                <LineChart size={24} data-id="element-72" />
              </div>
              <div data-id="element-73">
                <h3 className="text-xl font-semibold" data-id="element-74">Analytics Assistant</h3>
                <p className="text-gray-500 text-sm" data-id="element-75">
                  Turns data into insights
                </p>
              </div>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-76">
              Monitors your business metrics, generates reports, and sends
              alerts when important changes are detected.
            </p>
            <div className="flex justify-between items-center" data-id="element-77">
              <div className="flex items-center space-x-1" data-id="element-78">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-79">
                  Pro
                </span>
              </div>
              <button onClick={() => handleTryAgent('Analytics Assistant')} className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-80">
                Try this agent
              </button>
            </div>
          </div>
          <div className="bg-white p-6 rounded-xl border border-gray-100" data-id="element-81">
            <div className="flex items-center space-x-4 mb-4" data-id="element-82">
              <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center" data-id="element-83">
                <Users size={24} data-id="element-84" />
              </div>
              <div data-id="element-85">
                <h3 className="text-xl font-semibold" data-id="element-86">Recruitment Assistant</h3>
                <p className="text-gray-500 text-sm" data-id="element-87">
                  Streamlines hiring process
                </p>
              </div>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-88">
              Screens resumes, schedules interviews, and follows up with
              candidates to accelerate your hiring process.
            </p>
            <div className="flex justify-between items-center" data-id="element-89">
              <div className="flex items-center space-x-1" data-id="element-90">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-91">
                  Trending
                </span>
              </div>
              <button onClick={() => handleTryAgent('Recruitment Assistant')} className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-92">
                Try this agent
              </button>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-93">
          <button className="bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-94">
            View all agents
          </button>
        </div>
      </div>
      {/* Get Started Form */}
      <GetStartedForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-95" />
    </section>;
}